export const BaseUrl = "https://api.resortdecoracao.com"
 